
import 'intersection-observer';
import 'lightgallery';
import 'lg-thumbnail';

// import 'util-map';
require("expose-loader?customMap!../util/map");

import debounce from '../util/debounce';
import throttle from '../util/throttle';
import AOS from 'aos';
import imagesLoaded from 'imagesloaded';
import 'slick-carousel/slick/slick.min';
import Uncover from '../util/uncover';

let $window, $header;
let windowScrollTop = 0, headerOffsetTop = 0;

// window.initMap = window.initMap || function(){ console.log('default window.initMap'); };

export default {
  init() {

    $(document).ready(() => {

      $window = $(window);
      $header = $('header.banner');

      commonResize();
      commonScrolls();

      commonWowEffects();
      commonMenu();
      commonCarousels();
      commonContentList();
      commonGallery();

      commonModal();
      commonSocialSharing();

    });

  },
  finalize() {
    // JavaScript to be fired on all pages, after page specific JS is fired
  },
};


function commonModal() {
  $('.modal').on('modal.show', function(){
    $(this).addClass('is-active');
    if ( $('html').hasClass('menu-open') ) {
      $('html').addClass('menu-already-open');
    }
    $('html').addClass('menu-open');
  }).on('modal.hide', function(){
    $(this).removeClass('is-active');
    if ( $('html').hasClass('menu-already-open') ) {
      $('html').removeClass('menu-already-open');
    }
    else {
      $('html').removeClass('menu-open');
    }
  });
  $('.modal-close').on('click',function(e){
    e.preventDefault();
    $(this).parents('.modal').trigger('modal.hide');
  });
  $(document).on('click', '[data-modal-trigger]', function(e) {
    if ( $($(this).data('modal-trigger')).length ) {
      e.preventDefault();
      $($(this).data('modal-trigger')).trigger('modal.show');
    }
  });
}


function commonSocialSharing() {
  // Sociaux
  $(document).on('click', '.social-sharing', function(e) {
    var $parent = $(this).parent();
    var title = $parent.data('title') || window.location;
    var link = $parent.data('link') || $('head title').text();
    var thumbnail = $parent.data('thumbnail');

    if($(this).hasClass('facebook')) {
      e.preventDefault();
      window.open('http://www.facebook.com/sharer/sharer.php?u=' + encodeURIComponent(link), '', 'toolbar=0, status=0, width=900, height=500');
    }
    else if($(this).hasClass('twitter')) {
      e.preventDefault();
      window.open('https://twitter.com/intent/tweet?text=' + encodeURIComponent(title) + '&url=' + encodeURIComponent(link) + '&via=Bayard_Jeunesse', '', 'toolbar=0, status=0, width=650, height=360');
    }
    else if($(this).hasClass('googleplus')) {
      e.preventDefault();
      window.open('https://plus.google.com/share?hl=fr-FR&url=' + encodeURIComponent(link), '', 'toolbar=0, status=0, width=400, height=480');
    }
    else if($(this).hasClass('pinterest')) {
      e.preventDefault();
      window.open('http://pinterest.com/pin/create/button/?url=' + encodeURIComponent(link) + '&media=' + encodeURIComponent(thumbnail) + '&description=' + encodeURIComponent(title), '', 'toolbar=0, status=0, width=880, height=710');
    }
  });
  let delay = 0;
  $('#sticky-buttons a').each(function(){
    const $this = $(this);
    setTimeout(() => {
      $this.addClass('display-mini');
    }, delay);
    delay += 150;
  });
}


function commonWowEffects() {

  // var wow = new WOW(
  //   {
  //     boxClass:     'wow',      // animated element css class (default is wow)
  //     animateClass: 'animated', // animation css class (default is animated)
  //     offset:       0,          // distance to the element when triggering the animation (default is 0)
  //     mobile:       true,       // trigger animations on mobile devices (default is true)
  //     live:         true,       // act on asynchronously loaded content (default is true)
  //   }
  // );
  // wow.init();
  AOS.init({
    offset: 0,
    delay: 0,
    duration: 600,
    // easing: 'ease-in-sine',
    // once: false,
    // delay: 100,
  });

}

function commonMenu() {
  const toggleMenu = debounce( ( $el, target ) => {
    if ( target ) {
      const $target = $(target);
      $el.toggleClass('is-active');
      $target.toggleClass('is-active');
      if ( $target.hasClass('is-active') ) {
        $('html').addClass('menu-open');
      }
      else {
        $('html').removeClass('menu-open');
      }
    }
  }, 100 );
  const $navbarBurgers = $('.navbar-burger');
  $navbarBurgers.each((k, el) => {
    const $el = $(el);
    $el.on('touchstart', function (e) {
      e.preventDefault();
      e.stopPropagation();
      toggleMenu( $(this), $el.data('target') );
    }).on('click', function (e) {
      e.preventDefault();
      toggleMenu( $(this), $el.data('target') );
    });
  });
}

function _menuScroll() {
  if ( windowScrollTop >= 1 ) {
    $('html').addClass('scrolled');
  }
  else {
    $('html').removeClass('scrolled');
  }
  if ( windowScrollTop > headerOffsetTop ) {
    $('html').addClass('menu-fixed');
    $header.addClass('fixed');
  }
  else {
    $('html').removeClass('menu-fixed');
    $header.removeClass('fixed');
  }
}

function commonCarousels() {

  $('.page-header-banner .banner').slick({
    dots: false,
    arrows: false,
    infinite: true,
    speed: 1200,
    fade: true,
    cssEase: 'linear',
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 4500,
  });
  $('.carousel').slick({
    dots: false,
    arrows: true,
    infinite: true,
    speed: 800,
    fade: false,
    cssEase: 'linear',
    autoplay: true,
    autoplaySpeed: 4500,
    slidesToShow: 4,
    slidesToScroll: 2,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 3,
        },
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2,
        },
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
    ],
  });

}

function commonContentList() {
  const items = Array.from(document.querySelectorAll('.grid > .grid__item'));

  let uncoverArr = [];

  const observer = new IntersectionObserver((entries) => {
    entries.forEach(entry => {
      if ( entry.intersectionRatio > 0.2 ) {
        uncoverArr[items.indexOf(entry.target)].show(true, {
          slices: {duration: 600, delay: (_,i,t) => (t-i-1)*100, easing: 'easeInOutCirc'},
        });
      }
      else {
        uncoverArr[items.indexOf(entry.target)].hide(true, {
          slices: {duration: 600, delay: (_,i,t) => (t-i-1)*100, easing: 'easeInOutCirc'},
        });
      }
    });
  }, { threshold: 0.2 });

  $('body').addClass('loading');
  imagesLoaded($('.scroll-img').get(), {background: true}, () => {
    $('body').removeClass('loading');

    items.forEach((item) => {
      if ( $('.scroll-img', item).length ) {
        uncoverArr.push(new Uncover(item.querySelector('.scroll-img'), {
          // total number of slices.
          slicesTotal: 5,
          // slices color.
          slicesColor: '#f8f8f8',
          // 'vertical' || 'horizontal'.
          orientation: 'vertical',
          // 'bottom' || 'top' for vertical orientation and 'right' || 'left' for horizontal orientation.
          slicesOrigin: {show: 'top', hide: 'top'},
        }));
        observer.observe(item);
      }
    });
  });
}

function commonGallery() {
  $('.page-content-wrapper .gallery').lightGallery({
      thumbnail: true,
      selector: 'a',
      download: false,
      showThumbByDefault: false,
  });
  $('.page-gallery-wrapper .gallery').lightGallery({
      thumbnail: true,
      selector: 'a',
      download: false,
      showThumbByDefault: false,
  });
}

// function _pageHeaderScroll(windowScrollTop) {
//   var headlineHeight = $('.page-header-banner').outerHeight() - $('header.banner').height();
//   $('.page-header-banner .banner').css({
//     'opacity': (1 - windowScrollTop / headlineHeight),
//   });
//   $('.page-header-banner .inner').children().css({
//     'transform': 'translateY('+ windowScrollTop * 0.4 +'px)',
//     'opacity': (1 - windowScrollTop / headlineHeight),
//   });
// }

function commonScrolls() {
  let scrollTopLimited = throttle(() => {
    windowScrollTop = $window.scrollTop();
    _menuScroll();
    // _pageHeaderScroll();
  }, 50);
  scrollTopLimited();
  $window.on('scroll', scrollTopLimited);

  $('a.scroll-link[data-target]').on('click', function(e) {
      e.preventDefault();
      if( $(this).data('target') && $($(this).data('target')).length ) {
        let scroll = $($(this).data('target')).offset().top;
        if ( $($(this).data('target')).not($header.parent() ) ) {
          scroll -= $header.height();
        }
        $('html, body').animate({
          scrollTop: scroll,
        }, 1000);
      }
  });

}

function commonResize() {
  let resizeLimited = debounce(() => {
    headerOffsetTop = $header.parent().offset().top;
    AOS.refresh();
  }, 100, true);
  resizeLimited();
  $window.on('resize', resizeLimited);
}



// WEBPACK FOOTER //
// ./scripts/routes/common.js